import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../Master/database/database.service';
import { RequestdashboardService } from '../dashboard/requestdashboard/requestdashboard.service';
import { Database } from '../Master/database/database';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { UseraddService } from '../Master/useradd/useradd.service';
import { FormdashboardService } from '../dashboard/formdashboard/formdashboard.service';
import { UserService } from '../Master/user/user.service';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalService } from '../local.service';
import {encryptdecrypt} from '../encryptdecrypt';
import { FormrenderService } from '../formrender/formrender.service';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  //database details
  dataBases: any = [];
  databaseid: string = "";

  //user details
  conversionuser: number;
  openrequest: number;
  adminuser: number;
  public userid: number;
  _usermappedDatabase = [];
  formStatus: any = [];
  userRole: string = '';
  openForm: any = [];
  //request details
  requestlist: any = [];
  requestlisttmp: any = [];

  //access rights
  sendMenuId: number = 3;
  sendPageName: string = 'Home Dashboard';
  //menu rights
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  //pagination
  p: number = 1; searchTextforDatabase: string; itemsPerPage: number = 4;


  constructor(private databaseService: DatabaseService, private toastr: ToastrService, private requestdashboardservice: RequestdashboardService,
    private _sanitizer: DomSanitizer, private router: Router, private useraddService: UseraddService,
    private formdashboardservice: FormdashboardService, private userservice: UserService, 
    private SpinnerService: NgxSpinnerService, private localService: LocalService,
  private formRenderService: FormrenderService) { }

 
  //page init
  ngOnInit() {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    //this.userRole = localStorage.getItem('userrole');
    this.userRole = this.localService.getJsonValue('userrole');
   // this.getUnreadFormDetails();
    this.getUserMappedDatabase();
    this.getActionRightsList();
    this.loadproduct(0, 'Null', 1);
    $('.nav.side-menu li').removeClass('active');
    $('.menu_section .side-menu li').removeClass('active');
  }

  getActionRightsList() {
    this.userservice.Get().subscribe(res => {
      let allUser: any = [];
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == 38);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];

      }
      
      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1)
              this.readOnly = true;
            else if (d == 2) {
              this.readOnly = true;
              this.add = true;
              this.submitShow = true;
            }
            else if (d == 3) {
              this.readOnly = true;
              this.edit = true;
              // this.submitShow = true;
            }
            else if (d == 4) {
              this.readOnly = true;
              this.delete = true;
            }
          }
        });
      }
    });

  }

  formDashboardUnread(item) {
    //this.router.navigate(['/home/formdashboard', { 'db': item.dbid, 'formconfigid': item.formconfigid }]);
    let a= new encryptdecrypt();  
    var dbid= a.encryptUsingAES256(item.dbid.toString());
    var formconfigid= a.encryptUsingAES256(item.formconfigid.toString());
    this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': dbid, 'formconfigid': formconfigid } });
  }

  getUnreadFormDetails() {
    this.SpinnerService.show();
    this.formdashboardservice.GetUnreadFormCount(this.userid,'').subscribe(res => {
      if (res != undefined && res.length != 0) {
        this.formStatus = res;
        //console.log(this.formStatus);
      //  this.SpinnerService.hide();
      }

    });
  }

  //database loading user wise
  getUserMappedDatabase() {
    this.SpinnerService.show();
	//this.getUnreadFormDetails(); 							 
    //user wise database loding
    Promise.all([this.formdashboardservice.GetUnreadFormCount(this.userid, '').toPromise(), this.useraddService.GetById(this.userid).toPromise(), this.requestdashboardservice.GetAll().toPromise()]).then(([unread, userdata,request]) => {
      var data = []; let db: any = [];
      let dbuser: any = [];
      this.formStatus = unread;



      data = userdata;
       


      
      db = data.find(y => y.userid == this.userid);
      dbuser = data.find(y => y.userid == this.userid);
      //localStorage.setItem("userrole", db.userrole);
      this.localService.setJsonValue("userrole", db.userrole);
      this._usermappedDatabase = JSON.parse(dbuser.databasemapped).databasemapped;
      this.databaseService.getActive().toPromise().then(res => {
        var allData = [];
        allData = res;
        allData.forEach(item => {
          this._usermappedDatabase.forEach(a => {
            if (item.databaseid == a.databaseid) {
              this.dataBases.push({
                databaseid: item.databaseid,
                database: item.database,
                iconclass: item.iconclass,
                databasedescription: item.databasedescription,
                databaseiconpath: item.databaseiconpath,
                status: item.status,
                createdby: item.createdby,
                createdon: item.createdon,
                modifiedby: item.modifiedby,
                modifiedon: item.modifiedon,
                active: item.active,
                databaseicon: item.databaseicon,
                openrequest: 0
              });
            }
          });
        });

       

        //open request count binding
        //this.requestdashboardservice.GetAll().toPromise().then(res => {
        this.requestlist = request;
          this.openrequest = 0;
          this.requestlisttmp = [];
          this.dataBases.forEach(a => {
            this.getopenrequest(a.databaseid, dbuser, this.requestlist);
            a.openrequest = this.openrequest
          });
        //});

        //sorting databases    
       // this.dataBases.sort((a, b) => (a.sequenceno > b.sequenceno) ? -1 : 1);
        this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
		this.SpinnerService.hide();
						   
      }, err => {
this.SpinnerService.hide();
        this.toastr.error('Error while getting the database data ');
		

      });

      this.SpinnerService.hide();
    }, error => {
      //console.log(error)
    });
  }
  getbuttonenable(databaseid) {
    var s = this.formStatus.filter(x => x.dbid == databaseid);
    if (s.length != 0)
      return true;
    else
      return false;
  }
  //Navigate to form dashboard
  formDashboard(database) {
    //this.router.navigate(['/home/formdashboard', { 'db': database.databaseid }]);
    let formConfigValue = this.formStatus.filter(x => x.dbid == database.databaseid);
    let a= new encryptdecrypt();  
    var dbid= a.encryptUsingAES256(database.databaseid.toString());
    if (formConfigValue.length > 0) {
     // this.router.navigate(['/home/formdashboard', { 'db': database.databaseid }]);
      this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': dbid } });
    } else {
      this.router.navigate(['/home/requestdashboard', { 'db': dbid }]);
    }

  }

  //Navigate to request dashboard
  requestDashboard(database) {
    let a= new encryptdecrypt();  
    var dbid= a.encryptUsingAES256(database.databaseid.toString());
    this.router.navigate(['/home/requestdashboard', { 'db': dbid }]);
  }

  //Navigate to form render 
  formRender(database, type) {
    //alert(database);
    var data = database;
    if ((data != undefined) && (data.length != 0)) {
      this.databaseid = data.databaseid + '*' + data.database;
      let a= new encryptdecrypt();  
     var dbid= a.encryptUsingAES256(this.databaseid.toString());
     var mode= a.encryptUsingAES256('addByDashboard');
      if (type == 'documents') {
        this.router.navigate(['/home/formrender'], { queryParams: { 'db': dbid, 'mode': mode } });
      }
       // this.router.navigate(['/home/formrender', { 'db': this.databaseid }]);
       
      if (type == 'requests') {
        var _dbid= a.encryptUsingAES256(database.databaseid.toString());  
        this.router.navigate(['/home/requestconfig', { 'db':_dbid }]);
      }
       

    }
  }

  //Get open request details
  getopenrequest(dbid, currentuserdetails, requestdetails) {
    this.requestlisttmp = [];
    //others
    if ((currentuserdetails.requestmapped != null)) {
      {
        var request1 = JSON.parse(currentuserdetails.requestmapped);
        if (request1.requestmapped.length)
          this.conversionuser = 1;
      }
    }
    else
      this.conversionuser = 0;
    if (currentuserdetails.userrole == "Admin")
      this.adminuser = 1;
    requestdetails.forEach(data => {
      if (this.conversionuser == 1) {
        var request = JSON.parse(currentuserdetails.requestmapped);
        for (var i = 0; i < request.requestmapped.length; i++) {
          if (data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid && data.requesttypeid == request.requestmapped[i].requesttypeid) {
            this.requestlisttmp.push(data);
          }
        }
      }
      else if (this.adminuser == 1) {
        if (data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid) {
          this.requestlisttmp.push(data);
        }
      }
      else {
        if (data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid && data.createdby == currentuserdetails.userid) {
          this.requestlisttmp.push(data);
        }
      }
    });
    this.openrequest = this.requestlisttmp.length;
  }


   loadproduct(productid, product, active) {
     
      this.SpinnerService.show();
      //let apitoken=this.localService.getJsonValue("apitoken");
      var apitoken=this.localService.getJsonValue('apitoken');
      this.formRenderService.LoadProduct(productid, product, active,apitoken).subscribe(
        (res) => {
          console.log(res);
          // this.product = JSON.parse(res[0].j);
          // this._dropdownSettings = {
          //   singleSelection: false,
          //   idField: 'ProductID',
          //   textField: 'Name',
          //   selectAllText: 'Select All',
          //   unSelectAllText: 'UnSelect All',
          //   itemsShowLimit: 7,
          //   allowSearchFilter: true
          // };
          // this.productItems = '';
          // this.product.forEach(element => {
          //   if (element.Name === 'Primary Source Documents') {
          //     this.productItems = [element];
          //   }
          // });
          this.SpinnerService.hide();
        },
  
        error => {
  
          this.SpinnerService.hide();
        });
    }

}
